import { Create } from 'react-admin'

import CollectionForm from './CollectionCodeForm'

const CollectionCreate = props => (
  <Create redirect="list" {...props}>
    <CollectionForm />
  </Create>
)

export default CollectionCreate
